export default "<component :is=\"elementName\" class=\"form-control-plaintext\">\n  <slot>{{ value }}</slot>\n</component>\n";